module.exports = __webpack_public_path__ + "img/branch_dark.e452c902.svg";